import { render, staticRenderFns } from "./trim-packages.vue?vue&type=template&id=79279026&scoped=true"
import script from "./trim-packages.vue?vue&type=script&lang=js"
export * from "./trim-packages.vue?vue&type=script&lang=js"
import style0 from "./trim-packages.vue?vue&type=style&index=0&id=79279026&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79279026",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VRow})
